import Banner from '@ben/orion/banner';
import { useTranslation } from 'react-i18next';

const ConfigWindowClosedBanner = () => {
  const { t } = useTranslation();

  return (
    <Banner
      title={t('benefit.configWindowClosedTitle')}
      message={t('benefit.configWindowClosedMessage')}
    />
  );
};

export default ConfigWindowClosedBanner;
